import apiInstance from '@apis/index';

export enum WeatherPath {
  DEFAULT = '/weather',
}

export const getWeatherData = async () => {
  return apiInstance.get(WeatherPath.DEFAULT);
};
